import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { personalInfo } from "../data/portfolio";

const navItems = [
  { label: "About", href: "#about" },
  { label: "Skills", href: "#skills" },
  { label: "Projects", href: "#projects" },
  { label: "Experience", href: "#experience" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const sections = document.querySelectorAll("section[id]");
      let current = "";
      sections.forEach((s) => {
        if (window.scrollY >= s.offsetTop - 130) current = s.id;
      });
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.23, 1, 0.32, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 md:px-12 h-16 transition-all duration-300 ${
        scrolled
          ? "bg-[#0a0a0f]/80 backdrop-blur-xl border-b border-white/[0.06]"
          : "bg-transparent"
      }`}
    >
      {/* Logo */}
      <a
        href="#hero"
        data-hover
        className="font-display font-black text-xl grad-text tracking-tight"
      >
        UK.
      </a>

      {/* Links */}
      <ul className="hidden md:flex items-center gap-8">
        {navItems.map((item) => (
          <li key={item.href}>
            <a
              href={item.href}
              data-hover
              className={`nav-link text-xs font-mono tracking-widest uppercase transition-colors duration-200 ${
                active === item.href.slice(1)
                  ? "text-white active"
                  : "text-white/40 hover:text-white"
              }`}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>

      {/* Resume CTA */}
      <a
        href={personalInfo.resumeUrl}
        download
        data-hover
        className="hidden md:flex items-center gap-2 px-4 py-2 rounded-md text-xs font-mono tracking-wide border border-white/10 text-white/60 hover:text-white hover:border-blue-400/30 hover:bg-white/[0.04] transition-all duration-300"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-green-400 shadow-[0_0_6px_#34d399]" />
        Resume
      </a>
    </motion.nav>
  );
}
